// import { Vertical } from '../modules/wizards/components/Vertical'
import { Horizontal } from '../modules/wizards/components/Horizontal'


export function DevOpsCalculatorPage() {
    return <Horizontal />
}